import { render, staticRenderFns } from "./textview.vue?vue&type=template&id=5174f462&"
import script from "./textview.vue?vue&type=script&lang=ts&"
export * from "./textview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5174f462')) {
      api.createRecord('5174f462', component.options)
    } else {
      api.reload('5174f462', component.options)
    }
    module.hot.accept("./textview.vue?vue&type=template&id=5174f462&", function () {
      api.rerender('5174f462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/textview.vue"
export default component.exports